import { cn } from '@discover-lib/utils';

export type InputVariantProps = {
  scale?: 'sm' | 'md' | 'lg';
};

export default function inputVariants({ scale }: InputVariantProps) {
  return cn(
    'flex rounded-sm border border-input bg-background ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray',
    {
      'px-4 py-2 text-sm': scale === 'sm',
      'px-6 py-3 text-base': scale === 'md',
      'px-7 py-3.5 text-base': scale === 'lg',
    }
  );
}
